import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import api from "../../../services/api";
import Loader from "../../../components/loader";
import toast from "react-hot-toast";
import Current from "./current";
import Prompts from "./prompts";
import Chat2 from "./chat2";
import Notes from "./notes";
import Occupation from "./occupation";
import Xml from "./xml";
import Skills from "./skills";
import Questions from "./questions";
import Upsell from "./upsell";
import Kpis from "./kpis";
import Chat from "./chat";
import Tasks from "./tasks";

export default function PeopleView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("current");
  const [note, setNote] = useState({ text: "", id: null, isVisible: false });

  useEffect(
    function () {
      getUser();
    },
    [id],
  );

  async function getUser() {
    try {
      setLoading(true);
      const { data, ok } = await api.get(`/user/${id}`);
      if (!ok) return toast.error(data.error);
      setUser(data);
    } catch (error) {
      console.error("Error loading user:", error);
    } finally {
      setLoading(false);
    }
  }

  function openProfileModal() {
    const query = new URLSearchParams(location.search);
    query.set("user_modal_id", id);
    navigate({ search: query.toString() });
  }

  if (loading) return <Loader />;
  if (!user) return <div>User not found</div>;

  return (
    <div className="p-2  mx-auto">
      <div className="flex items-center justify-between ">
        <div className="flex items-center ">
          <img
            src={user.avatar || "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"}
            alt={user.name}
            className="w-10 h-10 rounded-full object-cover border-2 border-gray-100"
          />
          <h1 className="text-2xl font-bold">{user.name}</h1>
        </div>
        <div className="flex items-center gap-2">
          <Link to={`/check`} target="_blank" className="flex items-center gap-2 px-3  rounded-md bg-blue-50 text-blue-700 hover:bg-blue-100 border border-blue-100 transition">
            <span className="inline-block w-2 h-2 rounded-full bg-blue-400" />
            <span className="font-medium">Budget Issues</span>
          </Link>
          <Link
            to={`/selecole/skills2`}
            target="_blank"
            className="flex items-center gap-2 px-3 rounded-md bg-green-50 text-green-700 hover:bg-green-100 border border-green-100 transition">
            <span className="inline-block w-2 h-2 rounded-full bg-green-400" />
            <span className="font-medium">Skills</span>
          </Link>
          <Link
            to={`/people?user_modal_id=${id}&user_modal_tab=activity`}
            target="_blank"
            className="flex items-center gap-2 px-3 rounded-md bg-yellow-50 text-yellow-700 hover:bg-yellow-100 border border-yellow-100 transition">
            <span className="inline-block w-2 h-2 rounded-full bg-yellow-400" />
            <span className="font-medium">Activity</span>
          </Link>
          <button
            className="flex items-center gap-2 px-3 rounded-md bg-gray-50 text-blue-700 hover:bg-gray-100 border border-gray-100 transition"
            onClick={openProfileModal}
            type="button">
            <span className="inline-block w-2 h-2 rounded-full bg-blue-300" />
            <span className="font-medium">Open Profile</span>
          </button>
        </div>
      </div>

      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => setActiveTab("current")}
            className={`${
              activeTab === "current" ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}>
            Projects
          </button>
          <button
            onClick={() => setActiveTab("occupation")}
            className={`${
              activeTab === "occupation" ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}>
            Occupation
          </button>
          <button
            onClick={() => setActiveTab("skills")}
            className={`${
              activeTab === "skills" ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}>
            Skills
          </button>
          <div className="mr-10" />
          <button
            onClick={() => setActiveTab("prompts")}
            className={`${
              activeTab === "prompts" ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}>
            Prompts & Goals
          </button>
          <button
            onClick={() => setActiveTab("kpis")}
            className={`${
              activeTab === "kpis" ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}>
            Kpis
          </button>
          <button
            onClick={() => setActiveTab("tasks")}
            className={`${
              activeTab === "tasks" ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}>
            Tasks
          </button>
          <button
            onClick={() => setActiveTab("chat")}
            className={`${
              activeTab === "chat" ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}>
            Chat
          </button>
          <button
            onClick={() => setActiveTab("notes")}
            className={`${
              activeTab === "notes" ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}>
            Notes
          </button>
          <button
            onClick={() => setActiveTab("questions")}
            className={`${
              activeTab === "questions" ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}>
            Questions
          </button>
          {/* <button
            onClick={() => setActiveTab("upsell")}
            className={`${
              activeTab === "upsell" ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}>
            Upsell
          </button> */}
        </nav>
      </div>

      {activeTab === "current" && <Current user={user} note={note} setNote={setNote} />}
      {activeTab === "prompts" && <Prompts user={user} setUser={setUser} />}
      {activeTab === "notes" && <Notes user={user} />}
      {activeTab === "occupation" && <Occupation user={user} />}
      {activeTab === "skills" && <Skills user={user} />}
      {activeTab === "chat" && <Chat user={user} setUser={setUser} />}
      {activeTab === "chat2" && <Chat2 user={user} setUser={setUser} />}
      {activeTab === "xml" && <Xml user={user} />}
      {activeTab === "questions" && <Questions user={user} />}
      {activeTab === "upsell" && <Upsell user={user} />}
      {activeTab === "kpis" && <Kpis user={user} />}
      {activeTab === "tasks" && <Tasks user={user} setUser={setUser} />}
    </div>
  );
}
